import React from "react"
import { Button, IconUpload } from "dash-styled"
import { routePaths } from "../../../../../../../Routes"
import { NavButton } from "../../../../../NavButton/NavButton"

interface Props {
    layout: "absolute" | "relative"
    single: boolean
    orgUsername: string
    onDownloadExample: () => void
}

export const CSVButtons: React.FC<Props> = ({
    layout,
    single,
    orgUsername,
    onDownloadExample
}: Props) => {
    const btnClasses =
        "ml-2 text-gray-600 text-sm flex justify-between flex-1 items-center max-w-min-content min-w-max-content"

    return (
        <div
            className={`relative ${
                layout === "relative" ? "flex justify-end" : ""
            }`}
        >
            <div
                className={`flex justify-end right-0 w-3/4 z-10 ${layout} -mt-1`}
            >
                {!single && (
                    <NavButton
                        color="white"
                        to={routePaths.datasets(orgUsername)}
                        className={btnClasses}
                        size="xs"
                        variant="contained2"
                    >
                        <span className="flex mr-1">
                            <IconUpload size="sm" style={{ margin: 0 }} />
                        </span>
                        <span className="ml-1">Convert files to URLs</span>
                    </NavButton>
                )}
                <Button
                    onClick={onDownloadExample}
                    color="white"
                    className={btnClasses}
                    size="xs"
                    variant="contained2"
                    testId="download-sample-csv"
                >
                    <span className="flex mr-1 item">
                        <IconUpload
                            size="sm"
                            style={{
                                margin: 0,
                                transform: "rotate(180deg)"
                            }}
                        />
                    </span>
                    <span className="ml-1 color-grey">Download sample CSV</span>
                </Button>
            </div>
        </div>
    )
}
